import { invert } from 'lodash';

export function isNotUndefined<T>(param: T | undefined): param is T {
  return param !== undefined;
}

export const isDefined = <T>(value: T | null | undefined): value is T => value != null;

export function invertMapTyped<Source extends string, Target extends string>(
  mapping: Partial<Record<Source, Target>>,
): Partial<Record<Target, Source>> {
  return invert(mapping) as Partial<Record<Target, Source>>;
}

export type DeepPartial<T> = {
  [P in keyof T]?: T[P] extends object
    ? T[P] extends (...args: any[]) => any
      ? T[P]
      : DeepPartial<T[P]>
    : T[P];
};

export type TypeGuardResult<T> = T extends (
  input: unknown,
  ...args: unknown[]
) => input is infer Guarded
  ? Guarded
  : never;

export function assertNever(x: never, msg?: string): never {
  throw new Error(`${msg}: ${String(x)}`);
}
